import { IAppState } from '../../redux';
import { EBetPositionErrorCode } from '../../redux/reducers';
import { selectBetPositionErrorCode } from './selectBetPositionErrorCode';

const SERVER_ERRORS: (EBetPositionErrorCode | null)[] = [EBetPositionErrorCode.serverError];

export function selectNeedBetPositionReload(state: IAppState): boolean {
  const errorCode = selectBetPositionErrorCode(state);

  return SERVER_ERRORS.includes(errorCode);
}
